import { Skeleton } from "~/components/ui/skeleton";

export function DramaCardLightSkeleton() {
  return (
    <div className="flex flex-col gap-[8px]">
      <Skeleton className="aspect-[2/3] w-full rounded-[12px]" />
      <Skeleton className="h-[20px] w-full" />
      <Skeleton className="h-[18px] w-2/3" />
    </div>
  );
}
